import { render } from "./AccountButton.vue?vue&type=template&id=3a6e10e5"
import script from "./AccountButton.vue?vue&type=script&lang=js"
export * from "./AccountButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__